module.exports = __webpack_public_path__ + "img/ag-logo.c9b3e104.png";